// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetAlloysPartnersShopifyFetchCollectionsResult = objectOf({
  collections: arrayOf(
    objectOf({
      id: string,
      title: string,
    })
  ),
});
